import router from '@/router'
import { ERROR_MESSAGES } from '@/constants/ERROR_MESSAGES'
import { COMPANY_SLUG_PLACEHOLDER, CURRENT_COMPANY_SLUG_STORAGE_KEY } from '@/constants/COMPANY_SLUG'

// The route's company wins; the session keeps the last one for routes without it.
export const getCurrentCompanySlug = (): string | null => {
  const companySlug = router.currentRoute.value.params.company || sessionStorage.getItem(CURRENT_COMPANY_SLUG_STORAGE_KEY)

  return companySlug ? String(companySlug) : null
}

// Throws when no company is known, rather than sending a request to `/null/...`.
export const replaceCompanySlugPlaceholder = (url: string): string => {
  if (!url.includes(COMPANY_SLUG_PLACEHOLDER)) {
    return url
  }

  const companySlug = getCurrentCompanySlug()
  if (!companySlug) {
    throw new Error(ERROR_MESSAGES.missedCurrentCompany)
  }

  return url.replace(COMPANY_SLUG_PLACEHOLDER, companySlug)
}
